import React, {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {View} from 'react-native';
import debounce from 'lodash/debounce';

import Pressable from '../Pressable';
import styles from './styles';
import DefaultIcon from '../../../images/md-icons/radio_button_unchecked/materialicons/24px.svg';
import CheckedIcon from '../../../images/md-icons/radio_button_checked/materialicons/24px.svg';

const RadioButton = ({
  checked: checkedProp,
  disabled,
  onPress: onPressProp,
  style,
}) => {
  const [checked, setChecked] = useState(checkedProp);

  useEffect(() => {
    setChecked(checkedProp);
  }, [checkedProp]);

  const onPress = useCallback(
    debounce(
      () => {
        if (disabled) {
          return;
        }

        const value = !checked;
        if (value) {
          setChecked(value);
        }

        if (onPressProp) {
          onPressProp(value);
        }
      },
      1000,
      {leading: true, trailing: false},
    ),
    [disabled, onPressProp, checked],
  );

  return (
    <Pressable
      allowBubbling
      disabled={disabled}
      onPress={onPress}
      style={{opacity: 1}}>
      <View style={[styles.root, style, disabled && styles.disabled]}>
        {!checked && <DefaultIcon fill="#4a4a49" />}
        {checked && <CheckedIcon fill="#231fda" />}
      </View>
    </Pressable>
  );
};
RadioButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  style: PropTypes.any,
};

export default RadioButton;
